import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Api } from '../api/api';
import { Observable } from 'rxjs';
import { base } from '../../assets/global';
import { TicketInfo, ParticipantStatusRequest, ParticipantStatusByAdminRequest, DeactivateUserStatusRequest } from '../../pages/event-ticket/event-ticket.model';

/*
  Generated class for the EventTicketProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class EventTicketProvider {

  constructor(private api: Api, private httpClient: HttpClient) {
    console.log('Hello EventTicketProvider Provider');
  }

  getTicketInfo(eventUid: string, email: string, userUid: string): Observable<TicketInfo> {
    return this.httpClient.get<TicketInfo>(`${base}api/mobility/GetTicketInfoForUserEvent?eventUid=${eventUid}&email=${email}&userUid=${userUid}`);
  }

  validateTicketInfo(eventUid: string, email: string): Observable<TicketInfo> {
    return this.httpClient.get<TicketInfo>(`${base}api/mobility/ValidateEmailForEvent?eventUid=${eventUid}&email=${email}`);
  }

  activateTicket(eventUid: string, email: string, userUid: string, code: string): Observable<TicketInfo> {
    return this.httpClient.post<TicketInfo>(`${base}api/mobility/ActivateTicketForUser?eventUid=${eventUid}&email=${email}&userUid=${userUid}&code=${code}`, {});
  }

  checkParticipantStatus(body: ParticipantStatusRequest): Observable<TicketInfo> {
    return this.httpClient.post<TicketInfo>(`${base}api/mobility/CheckParticipantStatus`, body);
  }

  checkParticipantStatusByAdminRequest(body: ParticipantStatusByAdminRequest): Observable<TicketInfo> {
    return this.httpClient.post<TicketInfo>(`${base}api/mobility/CheckParticipantStatusByAdmin`, body);
  }

  deactivateUserStatus(body: DeactivateUserStatusRequest): Observable<TicketInfo> {
    return this.httpClient.post<TicketInfo>(`${base}api/mobility/DeactivateUserStatus`, body);
  }

}



// WEBPACK FOOTER //
// ./src/providers/event-ticket/event-ticket.ts